/* Cool-Amp Conducto-Lube Co., Inc. theme script */
(function () {
  'use strict';
  var routes = window.routes || { cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_update_url: '/cart/update', cart_url: '/cart', root: '/' };
  var drawer = document.getElementById('CartDrawer');
  var lastFocus = null;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- mobile menu ---------- */
  var menuBtn = $('[data-menu-toggle]');
  var mobileNav = $('#MobileNav');
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('is-open');
      menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- cart drawer ---------- */
  function openDrawer() {
    if (!drawer) { window.location.href = routes.cart_url; return; }
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var closeBtn = $('[data-drawer-close]', drawer);
    if (closeBtn) closeBtn.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-drawer-open]');
    if (t && drawer) { e.preventDefault(); openDrawer(); }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawer(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
  });

  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; });
    $$('[data-cart-label]').forEach(function (el) { el.setAttribute('aria-label', 'Cart, ' + count + (count === 1 ? ' item' : ' items')); });
  }

  function refreshDrawer() {
    var url = routes.cart_url + (routes.cart_url.indexOf('?') > -1 ? '&' : '?') + 'section_id=cart-drawer';
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-drawer-inner]');
        var current = $('[data-drawer-inner]');
        if (fresh && current) current.replaceWith(fresh);
        var c = doc.querySelector('[data-drawer-count]');
        if (c) updateCount(parseInt(c.getAttribute('data-drawer-count'), 10) || 0);
      });
  }

  function postJSON(url, body) {
    return fetch(url + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Something went wrong.');
        return data;
      });
    });
  }

  function showError(form, msg) {
    var box = form && $('[data-form-error]', form);
    if (box) { box.textContent = msg; box.hidden = false; }
    else { window.alert(msg); }
  }

  /* add to cart (product forms, pair cards, upsell) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    var err = $('[data-form-error]', form); if (err) err.hidden = true;
    var fd = new FormData(form);
    var id = fd.get('id');
    if (!id) { showError(form, 'Please choose a size.'); return; }
    var qty = parseInt(fd.get('quantity') || '1', 10) || 1;
    form.classList.add('is-loading');
    postJSON(routes.cart_add_url, { items: [{ id: Number(id), quantity: qty }] })
      .then(refreshDrawer)
      .then(openDrawer)
      .catch(function (ex) { showError(form, ex.message); })
      .finally(function () { form.classList.remove('is-loading'); });
  });

  /* add both products */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-both]');
    if (!btn) return;
    e.preventDefault();
    var items = $$('form[data-pair-form]').map(function (f) {
      var id = new FormData(f).get('id');
      return id ? { id: Number(id), quantity: 1 } : null;
    }).filter(Boolean);
    if (!items.length) return;
    btn.classList.add('is-loading');
    postJSON(routes.cart_add_url, { items: items })
      .then(refreshDrawer).then(openDrawer)
      .catch(function (ex) { window.alert(ex.message); })
      .finally(function () { btn.classList.remove('is-loading'); });
  });

  /* drawer quantity / remove */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line-change]');
    if (!b) return;
    e.preventDefault();
    var line = parseInt(b.getAttribute('data-line'), 10);
    var qty = parseInt(b.getAttribute('data-qty'), 10);
    var inner = $('[data-drawer-inner]'); if (inner) inner.classList.add('is-loading');
    postJSON(routes.cart_change_url, { line: line, quantity: Math.max(0, qty) })
      .then(refreshDrawer)
      .catch(function (ex) { window.alert(ex.message); if (inner) inner.classList.remove('is-loading'); });
  });

  /* cart attributes (PO number) */
  document.addEventListener('change', function (e) {
    var el = e.target.closest('[data-cart-attr]');
    if (!el) return;
    var attrs = {}; attrs[el.getAttribute('data-cart-attr')] = el.value;
    postJSON(routes.cart_update_url, { attributes: attrs }).catch(function () {});
  });

  /* qty steppers on product page */
  document.addEventListener('click', function (e) {
    var s = e.target.closest('[data-qty-step]');
    if (!s) return;
    var input = $('input[name="quantity"]', s.closest('.qty'));
    if (!input) return;
    var v = (parseInt(input.value, 10) || 1) + parseInt(s.getAttribute('data-qty-step'), 10);
    input.value = Math.max(1, v);
  });

  /* ---------- variant picker (product page) ---------- */
  $$('[data-product-form]').forEach(function (form) {
    var dataEl = $('script[data-variants]', form.closest('[data-product]'));
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var root = form.closest('[data-product]');
    var priceEl = $('[data-price]', root);
    var coverEl = $('[data-coverage]', root);
    var sizeEl = $('[data-size-label]', root);
    var mainImg = $('[data-main-image]', root);
    var addBtn = $('[data-add-button]', root);
    function apply(id) {
      var v = variants.filter(function (x) { return String(x.id) === String(id); })[0];
      if (!v) return;
      if (priceEl) priceEl.textContent = v.price;
      if (coverEl) { coverEl.textContent = v.coverage || ''; coverEl.hidden = !v.coverage; }
      if (sizeEl) sizeEl.textContent = v.title;
      if (mainImg && v.image) { mainImg.src = v.image; mainImg.removeAttribute('srcset'); mainImg.alt = v.alt || mainImg.alt; }
      if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? addBtn.getAttribute('data-label-add') : addBtn.getAttribute('data-label-sold'); }
      $$('[data-thumb]', root).forEach(function (t) { t.setAttribute('aria-current', 'false'); });
      if (window.history && window.history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      }
    }
    form.addEventListener('change', function (e) { if (e.target.name === 'id') apply(e.target.value); });
    $$('[data-thumb]', root).forEach(function (t) {
      t.addEventListener('click', function () {
        if (mainImg) { mainImg.src = t.getAttribute('data-src'); mainImg.removeAttribute('srcset'); }
        $$('[data-thumb]', root).forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
      });
    });
  });

  /* ---------- pair cards (home) ---------- */
  $$('form[data-pair-form]').forEach(function (form) {
    var btnPrice = $('[data-pair-price]', form);
    var cov = $('[data-pair-coverage]', form);
    var img = $('[data-pair-image]', form.closest('.pair__card'));
    form.addEventListener('change', function (e) {
      if (e.target.name !== 'id') return;
      var o = e.target;
      if (btnPrice) btnPrice.textContent = o.getAttribute('data-price');
      if (cov) cov.textContent = o.getAttribute('data-coverage') || '';
      if (img && o.getAttribute('data-image')) img.src = o.getAttribute('data-image');
    });
  });
})();
